import type { FieldValidator } from '@lucidtech/las-sdk-browser';
import { memo } from 'react';

import { LogoProps } from '@/components/core';
import {
  ConfidenceLogo,
  CustomCodeLogo,
  DatabaseMatchLogo,
  LogicalExpressionLogo,
  NonEmptyLogo,
  RegexLogo,
  StringLogo,
  VariantLogoProps,
} from '@/components/logos';
import {
  VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID,
  VALIDATOR_CONFIDENCE_FUNCTION_ID,
  VALIDATOR_CUSTOM_CODE_FUNCTION_ID,
  VALIDATOR_DATABASE_MATCH_FUNCTION_ID,
  VALIDATOR_LOGEX_FUNCTION_ID,
  VALIDATOR_REGEX_FUNCTION_ID,
} from '@/constants';

export type ValidatorLogoProps = LogoProps & {
  validator: Omit<FieldValidator, 'id'>;
};

const IValidatorLogo = ({ validator, size, ...rest }: ValidatorLogoProps) => {
  const logoProps: VariantLogoProps = { size, variant: 'validator' };

  switch (validator.functionId) {
    case VALIDATOR_CONFIDENCE_FUNCTION_ID:
      return <ConfidenceLogo {...logoProps} {...rest} />;
    case VALIDATOR_LOGEX_FUNCTION_ID:
      return <LogicalExpressionLogo {...logoProps} {...rest} />;
    case VALIDATOR_REGEX_FUNCTION_ID:
      return <RegexLogo {...logoProps} {...rest} />;
    case VALIDATOR_CUSTOM_CODE_FUNCTION_ID:
      return <CustomCodeLogo {...logoProps} {...rest} />;
    case VALIDATOR_CANNOT_BE_EMPTY_FUNCTION_ID:
      return <NonEmptyLogo {...logoProps} {...rest} />;
    case VALIDATOR_DATABASE_MATCH_FUNCTION_ID:
      return <DatabaseMatchLogo {...logoProps} {...rest} />;
    default:
      return <StringLogo {...logoProps} {...rest} />;
  }
};

export const ValidatorLogo = memo(IValidatorLogo) as typeof IValidatorLogo;
